import StaffCommissionSales from './staff-commission-sales';

export default {
    StaffCommissionSales
};
